import { Component, output } from '@angular/core';
import {
  MatDatepickerModule,
  MatDateRangePicker,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  imports: [MatDatepickerModule, MatIconModule, MatFormFieldModule],
  selector: 'norupe-year-picker',
  styles: ``,
  templateUrl: './year-picker.component.html',
})
export class YearPickerComponent {
  startDate = output<Date | null>();
  endDate = output<Date | null>();

  //VALUES JUST FOR YEAR SELECTION SINCE THEY DONT SHOW UP WHEN SELECTING FROM A multi-year view

  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;

  onYearSelected(date: Date, datepicker: MatDateRangePicker<Date>) {
    const start = new Date(date.getFullYear(), 0, 1);
    const end = new Date(date.getFullYear(), 11, 31);

    this.setUiAndEmitDates(start, end);
    datepicker.close();
  }

  setUiAndEmitDates(start: Date | null, end: Date | null) {
    this.selectedStartDate = start;
    this.selectedEndDate = end;
    this.startDate.emit(start);
    this.endDate.emit(end);
  }
  clearDate() {
    this.setUiAndEmitDates(null, null);
  }
}
